import { createRouter } from '@tanstack/react-router';

import { queryClient } from './lib/query-client';
import { routeTree } from './routeTree.gen';

/**
 * queryClient віддається маршрутам у контексті, щоб `beforeLoad` міг
 * дочекатись сесії ДО малювання екрана — інакше захищена сторінка встигає
 * блимнути й лише потім перекидає на вхід.
 */
export const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreload: 'intent',
	scrollRestoration: true,
});

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}
